import logoNav from "@/assets/images/logo/logo-nav.webp";
import FooterContents from "@/components/Footer/FooterContents";
import drawerMenuItems from "@/data/nav/drawerMenuItems";
import navbarMenuItems from "@/data/nav/navbarMenuItems";

import {
  AppContainer,
  HeaderNav,
  MainFlexContainer,
  useScreenWidth,
  useScrollToHash,
} from "@crescentapplications/react-ui";
import { Outlet, ScrollRestoration } from "react-router";

export default function RootLayout() {
  useScrollToHash(true);
  const { laptopBreakpoint } = useScreenWidth();

  return (
    <AppContainer>
      <ScrollRestoration />

      <HeaderNav
        addNavbarLogo
        customNavbarLogo={
          <img
            src={logoNav}
            alt="Logo"
            style={{
              height: "1.9rem",
              width: "1.9rem",
            }}
          />
        }
        fixed
        isHashLinks
        breakpoint={laptopBreakpoint}
        drawerMenuItems={drawerMenuItems}
        navbarMenuItems={navbarMenuItems}
        addColorSchemeToggle
        addLanguageToggle
      />

      <MainFlexContainer>
        <Outlet />
      </MainFlexContainer>

      <FooterContents />
    </AppContainer>
  );
}
